import get from 'lodash/get'

const unwantedProps = [
  'activity',
  'ajParticipantEvent',
  'assessor',
  'createdAt',
  'createdBy',
  'createdByPerson',
  'continuationRegistration',
  'id',
  'invitedBy',
  'modifiedAt',
  'modifiedBy',
  'registrationDate',
  'residentialProject',
  'version'
]

export default (data = {}) => {
  const initialValues = {
    ...data,
    addressCountryId: get(data, 'countryId') || get(data, 'addressCountryId')
  }

  Object.keys(initialValues).map(key => {
    if (unwantedProps.includes(key)) {
      delete initialValues[key]
    }
  })

  return initialValues
}
